/******************************************************************************
 *                                                                            *
 *  Copyright (c) 2018, 2025 by AsterionDB Inc.                               *
 *                                                                            *
 *  All rights reserved.  No part of this work may be reproduced or otherwise *
 *  incorporated into other works without the express written consent of      *
 *  AsterionDB Inc.                                                           *
 *                                                                            *
 *****************************************************************************/

import React from 'react'

import { Form, FormFeedback, FormGroup, Button, Col, Row, Label, Input } from 'reactstrap'

import 'react-datetime/css/react-datetime.css';
import Datetime from 'react-datetime';
import InputNumber from 'rc-input-number';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import IPut from 'iput';
import LinuxModeBits from '../widgets/LinuxModeBits'

import {AppContext} from '../AppContext';

class EnrollContent extends React.Component
{
  isDateValid = undefined;
  ipAddress = null;
  linuxFileMode = 0;
  linuxSubdirMode = 0;

  constructor(props)
  {
    super();

    this.state =
    {
      generatedFilename: '',
      expireIn: '1 Minute',
      expirationDate: '',
      customDateDisabled: true,
      numericInputDisabled: true,
      sourceFilename: '',
      sourceFilenameValid: undefined,
      sourceFilenameFB: null,
      subdirUserGroup: '',
      subdirUserGroupValid: undefined,
      subdirUserGroupValidFB: null,
      fileUserGroup: '',
      fileUserGroupValid: undefined,
      fileUserGroupValidFB: null,
      ipAddressCheck: false,
      processIdCheck: false,
      sessionCheck: false,
      versionedObject: false,
      accessMode: 'W',
      accessLimit: 1,
      disableStreamWrite: false,
      generateDisabled: true,
      copyDisabled: true,
      processId: null
    }

    this.validDate = this.validDate.bind(this);
    this.customAccessLimitChanged = this.customAccessLimitChanged.bind(this);
    this.setAccessMode = this.setAccessMode.bind(this);
    this.setSourceFilename = this.setSourceFilename.bind(this);
    this.toggleCheckBox = this.toggleCheckBox.bind(this);
    this.setExpirationDate = this.setExpirationDate.bind(this);
    this.ipAddressChanged = this.ipAddressChanged.bind(this);
    this.processIdChanged = this.processIdChanged.bind(this);
    this.setLinuxFileMode = this.setLinuxFileMode.bind(this);
    this.setLinuxSubDirMode = this.setLinuxSubDirMode.bind(this);
  }

  customAccessLimitChanged(valueAsNumber, valueAsString, input)
  {
    this.setState({accessLimit: valueAsNumber});
  }
  
  expirationDateChanged(expireIn, event)
  {
    let disabled = true;
    let customDisabled = true;

    if ('Custom' === expireIn)
    {
      customDisabled = false;
      if ('' !== this.state.expirationDate && '' !== this.state.sourceFilename) disabled = false;
    }

    if ('Custom' !== expireIn && '' !== this.state.sourceFilename) disabled = false;

    this.setState(
    {
      customDateDisabled: customDisabled, 
      generateDisabled: disabled,
      expireIn: expireIn
    });
  }

  filenameCopied()
  {
    if ('' === this.state.generatedFilename)
    {
      this.context.postNotification('info', 'Generate a filename first.');
      return;
    }

    this.context.postNotification('info', 'Gateway filename copied to paste buffer.');
  }

  async generateFilename()
  {
    if (!this.ipAddressIsValid() && this.state.ipAddressCheck)
    {
      this.context.postNotification('error', 'Specify a valid IP Address');
      return;
    }

    if (this.state.processIdCheck && null === this.state.processId)
    {
      this.context.postNotification('error', 'Specify a process-id');
      return;
    }
    this.setState({generateDisabled: true});

    var bodyData = {};

    bodyData.gatewayName = this.context.appLocalStorage.getGatewayName();
    bodyData.source = this.state.sourceFilename;
    bodyData.accessMode = this.state.accessMode;

    switch (this.state.accessMode)
    {
      case 'W':
        bodyData.linuxFileMode = (this.linuxFileMode + 128).toString(8);
        bodyData.linuxSubdirMode = (this.linuxSubdirMode + 64 + 128 + 256).toString(8);
        break;

      case 'U':
        bodyData.linuxFileMode = (this.linuxFileMode + 128 + 256).toString(8);
        bodyData.linuxSubdirMode = (this.linuxSubdirMode + 64 + 128 + 256).toString(8);
        break;

      default:
        break;
    }

    bodyData.fileUserGroup = this.state.fileUserGroup;
    bodyData.subdirUserGroup = this.state.subdirUserGroup;
    bodyData.validUntil = ('Custom' === this.state.expireIn ? this.state.expirationDate.unix() : this.state.expireIn);
    bodyData.accessLimit = this.state.accessLimit;
    bodyData.disableStreamWrite = (this.state.disableStreamWrite ? 'Y' : 'N');
    bodyData.enforceIpSecurity = (this.state.ipAddressCheck ? 'Y' : 'N');
    bodyData.enforcePidSecurity = (this.state.processIdCheck ? 'Y' : 'N');
    bodyData.sessionMustBeActive = (this.state.sessionMustBeActive ? 'Y' : 'N');
    
    bodyData.clientIpAddress = this.ipAddress;
    bodyData.clientProcessId = this.state.processId;

    if (this.versionedObject)
      bodyData.versionedObject = 'Y';
    else
      bodyData.versionedObject = 'N';

    let result = await this.context.dbTwig.callRestAPI('dgBunker', 'createAnObject', bodyData);
    if ('success' !== result.status)
    {
      this.setState({generateDisabled: false, copyDisabled: true});
      return this.context.dbTwig.apiErrorHandler(result, 'Error enrolling content');
    } 

    this.setState({generatedFilename: result.jsonData.filename, generateDisabled: false});
    
    this.context.postNotification('info', "Filename generated.  Press the 'Copy..' buttons.");
  }

  ipAddressChanged(value)
  {
    this.ipAddress = value;
  }

  ipAddressIsValid()
  {
    if (null === this.ipAddress) return false;

    if (this.ipAddress.match(window.ipAddressRegEx))
      return true;
    else
      return false;
  }

  processIdChanged(value)
  {
    this.setState({processId: value});
  }

  render()
  {
    return(
      <div>
        <Row style={{paddingTop: "10px"}}>
          <Label sm="3" for="sourceFilename">Original (source) Location</Label>
          <Col sm="4">
            <Input type="text" id="sourceFilename" placeholder="Enter the original file name..." 
              value={this.state.sourceFilename} onChange={this.setSourceFilename} autoFocus
              invalid={( undefined ===  this.state.sourceFilenameValid ? undefined : !this.state.sourceFilenameValid)} 
              valid={( undefined ===  this.state.sourceFilenameValid ? undefined : this.state.sourceFilenameValid)} 
            />
            <FormFeedback valid={false}>{this.state.sourceFilenameFB}</FormFeedback>
          </Col>
        </Row>
        <Row style={{paddingTop: "10px"}}>
          <Col sm="3">Version Control</Col>
          <Col >
            <Form >
              <FormGroup check className="form-check-inline">
                <Label >
                  <Input type="radio" name="versionControlRadios" 
                    onChange={() => this.setState({versionedObject: false})} checked={!this.state.versionedObject}
                  />
                  Unversioned Object
                </Label>
              </FormGroup>
              <FormGroup check className="form-check-inline">
                <Label >
                  <Input type="radio" name="versionControlRadios" 
                    onChange={() => this.setState({versionedObject: true})} checked={this.state.versionedObject}
                  />
                  Versioned Object
                </Label>
              </FormGroup>
            </Form>
          </Col>
        </Row>
        <Row title="This setting governs how the program that uses the generated filename can open the object. It is not the same as the Linux file mode." style={{paddingTop: "10px"}}>
          <Col sm="3">Access Mode</Col>
          <Col>
            <Form >
              <FormGroup check className="form-check-inline">
                <Label check>
                  <Input type="radio" name="accessModeRadios" 
                    onChange={() => this.setState({accessMode: 'W'})} checked={('W' === this.state.accessMode)}
                  /> 
                  Write
                </Label>
              </FormGroup>
              <FormGroup check className="form-check-inline">
                <Label check>
                  <Input type="radio" name="accessModeRadios" 
                    onChange={() => this.setState({accessMode: 'U'})} checked={('U' === this.state.accessMode)}
                  /> 
                  Read/Write
                </Label>
              </FormGroup>
            </Form>
          </Col>              
        </Row>
        <Row title="This field allows you to set the traditional Linux file mode bits (e.g. rwxrwxrwx - 777). Note that the user read and write bits are set automatically based upon your selection for the Access Mode field." style={{paddingTop: "10px"}}>
          <Col sm="3">Linux Subdirectory Mode Bits</Col>
          <Col><LinuxModeBits fileOrSubdir={'subdir'} setValue={this.setLinuxSubDirMode}/></Col>
        </Row>
        <Row title="This field allows you to set the traditional Linux file mode bits (e.g. rwxrwxrwx - 777). Note that the user read and write bits are set automatically based upon your selection for the Access Mode field." style={{paddingTop: "10px"}}>
          <Col sm="3">Linux File Mode Bits</Col>
          <Col><LinuxModeBits fileOrSubdir={'file'} setValue={this.setLinuxFileMode}/></Col>
        </Row>
        <Row title="This field allows you to specify the ownership of the generated subdirectory and filename, if necessary. Leaving this field blank causes the filename and subdirectory ownership to be set to the user that is running the DbObscura Gateway that consumes the generated filename (e.g. asterion). Specify this value as 'user:group'."style={{paddingTop: "10px"}}>
          <Col sm="3">Subdir / File Ownership</Col>
          <Col sm='2'>
            <Input type="text" id="subdirUserGroup" 
              value={this.state.subdirUserGroup} onChange={this.setUserGroup.bind(this, 'subdir')} 
              invalid={( undefined ===  this.state.subdirUserGroupValid ? undefined : !this.state.subdirUserGroupValid)} 
              valid={( undefined ===  this.state.subdirUserGroupValid ? undefined : this.state.subdirUserGroupValid)} 
            />
            <FormFeedback valid={false}>{this.state.subdirUserGroupValidFB}</FormFeedback>
          </Col>
          <Col sm='2'>
            <Input type="text" id="subdirUserGroup" 
              value={this.state.fileUserGroup} onChange={this.setUserGroup.bind(this, 'file')} 
              invalid={( undefined ===  this.state.fileUserGroupValid ? undefined : !this.state.fileUserGroupValid)} 
              valid={( undefined ===  this.state.fileUserGroupValid ? undefined : this.state.fileUserGroupValid)} 
            />
            <FormFeedback valid={false}>{this.state.subdirUserGroupValidFB}</FormFeedback>
          </Col>
        </Row>
        <Row style={{paddingTop: "20px"}}>
          <Col sm='3'>
            <Label for="disableStreamWrite" check>
              Disable Stream Write
            </Label>
          </Col>
          <Col>
            <Form>
              <FormGroup check className="form-check-inline">
                <Input id="disableStreamWrite" type="checkbox" onChange={this.toggleCheckBox.bind(this, 'disableStreamWrite')} 
                  checked={this.state.disableStreamWrite ? "checked" : ''} />
              </FormGroup>
            </Form>
          </Col>
        </Row>
        <Row style={{paddingTop: "10px"}}>
          <Label sm="3">Access Limit</Label>
          <Col>
            <Form  >          
              <FormGroup check className="form-check-inline">
                <Label check>
                  <Input type="radio" name="accessLimitRadios" checked={1 === this.state.accessLimit}
                    onChange={this.setAccessLimit.bind(this, 1)}
                  />
                  One Time
                </Label>
              </FormGroup>
              <FormGroup check className="form-check-inline">
                <Label check>
                  <Input type="radio" name="accessLimitRadios"  checked={-1 === this.state.accessLimit}
                    onChange={this.setAccessLimit.bind(this, -1)}
                  />
                  Unlimited
                </Label>
              </FormGroup>
              <FormGroup check className="form-check-inline">
                <Label check>
                  <Input type="radio" name="accessLimitRadios"  checked={1 < this.state.accessLimit}
                    onChange={this.setAccessLimit.bind(this, 2)}
                  />
                  Custom
                </Label>
              </FormGroup>
              &nbsp;
              <FormGroup className="form-check-inline">
                <InputNumber id='accessLimit' min={2} max={99999} defaultValue={2} value={this.state.accessLimit} disabled={this.state.numericInputDisabled} 
                  onChange={this.customAccessLimitChanged} style={{ width: 100 }}/>
              </FormGroup>
            </Form>
          </Col>
        </Row>
        <Row style={{paddingTop: "10px"}}>
          <Col sm="3">Expiration Date</Col>
          <Col>
            <Form >
              <FormGroup check className="form-check-inline">
                <Label check>
                  <Input type="radio" name="expirationRadios" checked={('1 Minute' === this.state.expireIn)}
                    onChange={this.expirationDateChanged.bind(this, '1 Minute')} 
                  />
                  1 Minute
                </Label>
              </FormGroup>
              <FormGroup check className="form-check-inline">
                <Label check>
                  <Input type="radio" name="expirationRadios" checked={('1 Hour' === this.state.expireIn)}
                    onChange={this.expirationDateChanged.bind(this, '1 Hour')} 
                  />
                  1 Hour
                </Label>
              </FormGroup>
              <FormGroup check className="form-check-inline">
                <Label check>
                  <Input type="radio" name="expirationRadios" checked={('1 Day' === this.state.expireIn)}
                    onChange={this.expirationDateChanged.bind(this, '1 Day')} 
                  />
                  1 Day
                </Label>
              </FormGroup>
              <FormGroup check className="form-check-inline">
                <Label check>
                  <Input type="radio" name="expirationRadios" checked={('Custom' === this.state.expireIn)}
                    onChange={this.expirationDateChanged.bind(this, 'Custom')}
                  />
                  Custom
                </Label>  
              </FormGroup>
              <FormGroup className="form-check-inline">
                <Datetime onChange={this.setExpirationDate} value={this.state.expirationDate} 
                  inputProps={{disabled: this.state.customDateDisabled, placeholder: "Select a custom date..."}} isValidDate={this.validDate} />
              </FormGroup>
            </Form>
          </Col>
        </Row>
        <Row style={{paddingTop: "10px"}}>
          <Col sm="3">Security Settings</Col>
          <Col>
            <Form  >
              <FormGroup check className="form-check-inline">
                <Label check>
                  <Input type="checkbox" onChange={this.toggleCheckBox.bind(this, 'ipAddressCheck')} 
                    checked={this.state.ipAddressCheck ? "checked" : ''} />
                  IP Address Match
                </Label>
              </FormGroup>
              <FormGroup check className="form-check-inline">
                <Label check>
                  <Input type="checkbox" onChange={this.toggleCheckBox.bind(this, 'processIdCheck')} 
                    checked={this.state.processIdCheck ? "checked" : ''} />
                  System Process ID Match
                </Label>
              </FormGroup>
              <FormGroup check className="form-check-inline">
                <Label check>
                  <Input type="checkbox" onChange={this.toggleCheckBox.bind(this, 'sessionCheck')} 
                    checked={this.state.sessionCheck ? "checked" : ''} />
                  Session Must Be Active
                </Label>
              </FormGroup>
            </Form>
          </Col>
        </Row>
        { true === this.state.ipAddressCheck && 
        <Row style={{paddingTop: "10px"}}>
          <Col sm='3'><Label>IP Address</Label></Col>
          <Col><IPut  onChange={this.ipAddressChanged}/></Col>
        </Row>
      }
      { true === this.state.processIdCheck && 
        <Row style={{paddingTop: "10px"}}>
          <Col sm='3'>Process ID</Col>
          <Col sm='1'><InputNumber value={this.state.processId} onChange={this.processIdChanged} controls={false}/></Col>
        </Row>
      }
        <Row style={{paddingTop: "10px"}}>
          <Col sm="3">
            <Button disabled={this.state.generateDisabled} onClick={() => this.generateFilename()} color="primary">Generate Filename</Button>
          </Col>
          <Col>
            <CopyToClipboard text={this.state.generatedFilename} onCopy={() => this.filenameCopied()}>
              <div title='Click to copy...' ><small>{this.state.generatedFilename}</small></div>
            </CopyToClipboard>          
          </Col>
        </Row>
      </div>
    );
  }

  setAccessMode(mode)
  {
    this.setState({accessMode: mode});
  }

  setAccessLimit(limit)
  {
    let disabled = (1 < limit ? false : true);
    this.setState(
    {
      accessLimit: limit,
      numericInputDisabled: disabled
    });
  }

  setExpirationDate(parm)
  {
    let disabled = ('object' === typeof parm ? false : true);
    this.setState({expirationDate: parm._d, generateDisabled: disabled});
  }

  setLinuxFileMode(value)
  {
    this.linuxFileMode = value;
  }

  setLinuxSubDirMode(value)
  {
    this.linuxSubdirMode = value;
  }
  
  setSourceFilename(event)
  {
    let feedback = null;
    let valid = undefined;
    let disabled = true;

    if ('' === event.target.value)
    {
      feedback = 'You must enter the original source of the filename.';
      valid = false;
    }
    else
    {
      let dot = event.target.value.lastIndexOf('.');
      if (-1 !== dot && dot !== (event.target.value.length - 1)) 
        valid = true;
      else
      {
        feedback = 'You must include a file extension at the end of the filename.';
        valid = false;
      }

      if ('Custom' === this.state.expireIn && 'object' === typeof this.state.expirationDate && valid)
        disabled = false;

      if ('Custom' !== this.state.expireIn && valid) disabled = false;
    }

    this.setState(
    {
      sourceFilenameFB: feedback,
      sourceFilename: event.target.value,
      sourceFilenameValid: valid,
      generateDisabled: disabled
    });
  }

  setUserGroup(element, event)
  {
    if ('file' === element) 
      this.setState({fileUserGroup: event.target.value});
    else
      this.setState({subdirUserGroup: event.target.value});
  }

  toggleCheckBox(element)
  {
    this.setState({ [element]: !this.state[element]});
    if ('ipAddressCheck' === element) this.ipAddress = null;
  }

  validDate(current)
  {
    this.isDateValid = current.isAfter(this.yesterday);
    return this.isDateValid;
  } 
}

EnrollContent.contextType = AppContext;

export default EnrollContent